import { useContext } from 'react';

import ProposalDrawerContext from './ProposalDrawerContext';

export default function useProposalDrawer() {
  const context = useContext(ProposalDrawerContext);

  return context;
}
